import { ActivityLogs } from 'features/activityLogs'
import { useUserDetailsContext } from '../../../../../providers/UserDetailsProvider'
import React from 'react'

export const ActivityLogsTab = () => {
	const { user } = useUserDetailsContext()

	return <ActivityLogs userName={user.ObjectMeta.Name} />
}
